import { Utils } from "../utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { Coords } from "@/model/Coords";
import { AddressData } from "./AddressData";
import { MapCoords } from "./MapCoords";

export interface IHereLocation {
    title: string;
    id: string;
    resultType: string;
    houseNumberType: string;
    address: AddressData;
    position: Coords;
    access: Coords;
    distance: string;
    mapView: MapCoords;
    what3Words: string;
}

export class HereLocation implements IHereLocation {

    constructor(data?: IHereLocation) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IHereLocation) {
        mapData(data, { 
            root: () => this,
            coordinates: () => new Coords() });
    }

    title: string = "";
    id: string = "";
    resultType: string = "";
    houseNumberType: string = "";
    address: AddressData = new AddressData();
    position: Coords = new Coords();
    access: Coords = new Coords();
    distance: string = "";
    mapView: MapCoords = new MapCoords();
    what3Words: string = "";

}